// Vaultavo leadership team.
// `imageBg` and `imageObjectPosition` are optional overrides for
// non-standard source artwork (e.g. studio black backdrop).
export const LEADERSHIP = [
  {
    id: "philip-meyer",
    name: "Philip Meyer",
    role: "Founder & Chief Executive Officer",
    bio: "Global fintech entrepreneur with 35+ years of experience building and scaling payments, digital banking, and financial infrastructure businesses across international markets. Previously Group Executive and Founder of Transact24.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/1al8w47o_Philip%20Meyer.png",
  },
  {
    id: "gideon-malherbe",
    name: "Gideon Malherbe",
    role: "Co-Founder & Chief Strategy Officer",
    bio: "Serial entrepreneur and strategic advisor specializing in transformation, growth strategy, and scenario planning for global corporations and emerging technology ventures.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/ehyv2eg3_Gideon%20Malherbe.png",
  },
  {
    id: "keith-kourie",
    name: "Keith Kourie",
    role: "Co-Founder & Chief Technology Officer",
    bio: "Blockchain and cryptography specialist with extensive experience in secure payments infrastructure, digital banking technologies, and enterprise smartcard systems. Previously Group CIO within Nasdaq-listed Net1.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/e2eh5e9q_Keith%20Kourie.jpg",
  },
  {
    id: "james-fick",
    name: "James Fick",
    role: "Co-Founder & Chief Commercial Officer",
    bio: "Fintech and payments executive focused on commercial strategy, market expansion, and business development across digital assets and financial services. Previously held senior roles at Paymentology and Transact24.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/ljwjs3nt_James%20Fick.png",
  },
  {
    id: "joshua-brown",
    name: "Joshua Brown",
    role: "Head of Brand & Marketing",
    bio: "Leads Vaultavo's global brand, marketing strategy, digital presence, and strategic communications. Experienced across fintech analytics, growth strategy, investor collateral, and commercial enablement.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/mdb7jpyf_Joshua%20Brown.png",
  },
  {
    id: "peter-harris",
    name: "Peter Harris",
    role: "Chief Compliance Officer",
    bio: "Compliance and risk executive with extensive experience across regulated financial institutions, including roles at Morgan Stanley and Transact24.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/6wv92akd_Peter%20Harris.png",
  },
  {
    id: "ernest-lau",
    name: "Ernest Lau",
    role: "CTO Payments",
    bio: "Payments technology specialist experienced in transaction infrastructure, smartcard systems, and enterprise fintech platforms. Previously Group CIO at Transact24 Payments.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/1qe6xexz_Ernest.jfif",
  },
  {
    id: "josephine-wu",
    name: "Josephine Wu",
    role: "Chief Financial Officer",
    bio: "Finance executive overseeing corporate financial management, governance, and operational planning across fintech and payments businesses.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/bl6ixso6_Josephine.png",
  },
  {
    id: "robert-soden",
    name: "Robert Soden",
    role: "Corporate Development",
    bio: "International business development executive with experience spanning payments, identity services, institutional partnerships, and global market expansion.",
    photo:
      "https://customer-assets.emergentagent.com/job_custody-layer/artifacts/ev8ews7z_Robert%20Soden.png",
  },
];

export const initialsOf = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
